import { render, staticRenderFns } from "./PostDialog.vue?vue&type=template&id=071982d9&scoped=true&"
import script from "./PostDialog.vue?vue&type=script&lang=js&"
export * from "./PostDialog.vue?vue&type=script&lang=js&"
import style0 from "./PostDialog.vue?vue&type=style&index=0&id=071982d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071982d9",
  null
  
)

export default component.exports